export function parseXmlToNeutralTree(source, side = "Input") {
  const text = String(source ?? "");
  if (!text.trim()) throw new Error(`${side} XML is empty.`);
  if (/<!DOCTYPE[\s>]/i.test(text)) throw new Error(`${side} XML cannot contain a DOCTYPE declaration.`);
  const documentNode = new DOMParser().parseFromString(text, "application/xml");
  if (documentNode.querySelector("parsererror")) throw new Error(`${side} XML is invalid.`);
  if (!documentNode.documentElement) throw new Error(`${side} XML does not contain a document element.`);
  return neutralElement(documentNode.documentElement);
}

function neutralElement(element) {
  return {
    type: "element",
    namespace: element.namespaceURI || "",
    localName: element.localName || element.nodeName,
    attributes: Array.from(element.attributes)
      .filter(attribute => attribute.namespaceURI !== "http://www.w3.org/2000/xmlns/")
      .map(attribute => ({
        namespace: attribute.namespaceURI || "",
        localName: attribute.localName || attribute.name,
        value: attribute.value
      })),
    children: Array.from(element.childNodes).flatMap(node => {
      if (node.nodeType === Node.ELEMENT_NODE) return [neutralElement(node)];
      if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) {
        return node.nodeValue?.trim() ? [{ type: "text", value: node.nodeValue }] : [];
      }
      return [];
    })
  };
}
